import { summaryPromptType, summaryType } from "../models/APIModels";

export const ebookSummaryIngestions = (
  summaryPromptTypes: any,
  summaryTypes: string,
  project_id: string,
  custom_prompt?: string
) => {
  const text = "```{text}```";
  let payload = {};
  let words = "";
  if (summaryTypes === summaryType.compact) {
    words = "120";
  } else if (summaryTypes === summaryType.standard) {
    words = "500";
  } else if (summaryTypes === summaryType.comprehensive) {
    words = "1024";
  }
  if (summaryPromptTypes === summaryPromptType.heading_summary) {
    payload = {
      question_prompt_template: `Please provide a Heading and summary of the following text.
            TEXT: {text}
            HEADING:
            SUMMARY: Should be atleast in ${words} words`,

      refine_prompt_template: `Write a concise E-Book summary of the following text delimited by triple backquotes.
            Return your response in Heading and summary which covers summary of the text.
            ${text}
            HEADING:
            SUMMARY: Should be atleast in ${words} words`,
      summarization_type: summaryPromptTypes,
      summarization_method: summaryTypes,
      project_id: project_id,
    };
  } else if (summaryPromptTypes === summaryPromptType.heading_summary_key) {
    payload = {
      question_prompt_template: `Please provide a Heading and summary and keypoints of the following text.
            TEXT: {text}
            HEADING:
            SUMMARY:Should be atleast in ${words} words
            KEYPOINTS:`,

      refine_prompt_template: `You act as an expert in E-Book summarization and
            Write a concise E-Book summary of the following text delimited by triple backquotes.
            Return your response in Heading and summary and keypoints which covers summary of the text.
            ${text}
            HEADING:
            SUMMARY: Should be atleast in ${words} words
            KEYPOINTS:`,
      summarization_type: summaryPromptTypes,
      summarization_method: summaryTypes,
      project_id: project_id,
    };
  } else if (summaryPromptTypes === summaryPromptType.extract_topic) {
    payload = {
      question_prompt_template: `You act as an expert in E-BOOK Retrieval Agent and
            Strictly Do not make up any sentence or modify the content
            NOTE: If ${custom_prompt} are not present in given text then provide "Loading"
            Return your response in ${custom_prompt} which covers the extracted ${custom_prompt} content of the text of the following text.
            TEXT: {text}
            ${custom_prompt}:Provid ${custom_prompt} and content as it is from the text.`,
      refine_prompt_template: `You act as an expert in E-BOOK Retrieval Agent and
            Please extract ${custom_prompt} and its content as it is of the following text delimited by triple backquotes.
            Strictly Do not make up any sentence or modify the content
            NOTE: If ${custom_prompt} are not present in given text then provide "Loading"
            Return your response in ${custom_prompt} which covers the extracted ${custom_prompt} content of the following text.
      ${text}
      ${custom_prompt}:Provid ${custom_prompt} and content as it is from the text.`,
      project_id: project_id,
      summarization_method: summaryTypes,
      summarization_type: summaryPromptTypes,
    };
  } else if (summaryPromptTypes === summaryPromptType.custom_insights) {
    payload = {
      question_prompt_template: `${custom_prompt}.
                    TEXT: {text} .
                  Summary should be atleast in 100 words`,

      refine_prompt_template: `${custom_prompt}.
                    ${text}.
                    Summary should be in 120 words`,
      project_id: project_id,
      summarization_method: summaryTypes,
      summarization_type: summaryPromptTypes,
    };
  }

  return payload;
};
